import { Link } from 'components/Link'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import Trans from 'next-translate/Trans'
import { ReactNode } from 'react'
import { RawDietRoot, TextContainer } from './RawDiet.styles'

export const RawDiet = () => {
  const { t } = useTranslation()

  return (
    <RawDietRoot>
      <Stack direction="column" gap="4">
        <Stack direction="column" gap="3">
          <Text as="h2" size="h2" color="primary-800" weight="bold" align="center" display="block">
            {t('raw-benefits:raw-diet.title')}
          </Text>
          <Text size="headline" color="primary-800" weight="bold" align="center" display="block">
            {t('raw-benefits:raw-diet.headline')}
          </Text>
        </Stack>
        <div>
          <TextContainer>
            <Text size="headline" color="primary-800" align="center" display="block">
              <Trans
                i18nKey="raw-benefits:raw-diet.body"
                components={{ link: <LinkText href="/why-we-feed-raw" /> }}
              />
            </Text>
          </TextContainer>
        </div>
      </Stack>
    </RawDietRoot>
  )
}

export const LinkText = ({ children, href }: { href: string; children?: ReactNode }) => {
  return (
    <Link href={href} passHref>
      <Text as="a" size="headline" underline>
        {children}
      </Text>
    </Link>
  )
}
